const cards = [
  {
    title: '某顶流男星出轨实锤：时间线完整梳理',
    desc: '从深夜同回酒店到亲密合照曝光，多方证据链指向这位顶级艺人婚内出轨，品牌方已开始解约。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20hotel%20corridor%20with%20mysterious%20silhouettes%2C%20dramatic%20shadows%2C%20paparazzi%20style%2C%20noir%20cinematography%2C%20red%20exit%20sign%20glow%2C%20tense%20atmosphere&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '深度追踪',
    time: '2小时前',
    views: '128万',
  },
  {
    title: '知名女星整容前后医生实名爆料',
    desc: '整形医生违反保密协议实名曝光某一线女星多次手术记录，从面部轮廓到身材管理全方位分析。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20medical%20clinic%20interior%20with%20dramatic%20lighting%2C%20mysterious%20files%20on%20desk%2C%20noir%20medical%20theme%2C%20red%20and%20black%20aesthetic%2C%20tense%20atmosphere&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '独家爆料',
    time: '5小时前',
    views: '96万',
  },
  {
    title: '某综艺导演被爆潜规则多位参赛选手',
    desc: '多位匿名选手站出来指控某知名综艺导演利用职务之便进行不当行为，节目组紧急回应引发更大争议。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20audition%20room%20with%20empty%20chairs%20and%20spotlight%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20noir%20style%2C%20red%20accent%20lighting%20on%20dark%20stage&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '重磅新闻',
    time: '8小时前',
    views: '210万',
  },
  {
    title: '网红主播偷税漏税金额曝光令人咋舌',
    desc: '税务部门公布最新查处名单，多位头部主播涉及数千万税款未缴纳，平台已配合冻结相关账号。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20office%20desk%20with%20scattered%20money%20and%20documents%2C%20dramatic%20overhead%20light%2C%20tax%20investigation%20theme%2C%20noir%20atmosphere%2C%20red%20stamps%20and%20black%20shadows&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '财税风波',
    time: '1天前',
    views: '185万',
  },
  {
    title: '某女团成员被经纪人长期PUA录音流出',
    desc: '一段长达40分钟的录音揭露了某知名女团背后的经纪公司压榨内幕，粉丝集体发声要求公司回应。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20recording%20studio%20with%20vintage%20microphone%2C%20dramatic%20lighting%2C%20mysterious%20vibe%2C%20noir%20music%20theme%2C%20red%20and%20black%20color%20palette&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '行业黑幕',
    time: '1天前',
    views: '156万',
  },
  {
    title: '两位一线明星片场大打出手原因曝光',
    desc: '某大制作剧组两位主演因番位之争在拍摄现场爆发肢体冲突，导致当天拍摄全面停工损失数百万。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20movie%20set%20with%20overturned%20equipment%2C%20dramatic%20shadows%2C%20broken%20camera%2C%20noir%20film%20production%20theme%2C%20red%20warning%20lights%2C%20tense%20atmosphere&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '剧组冲突',
    time: '2天前',
    views: '98万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选黑料</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-1 rounded-full bg-primary-500/90 text-background-50 font-medium">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-300">{card.time}</span>
                  <span className="text-xs text-foreground-300 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors text-sm mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}